import { useTranslation } from "react-i18next";
import { PreferenceComponent } from "../PreferenceComponent";

export const CollaboratorNotificationsContent = ({
  addedAsCollaboratorEmailEnabledRef,
  userNotificationData,
  onChange,
}) => {
  const { t } = useTranslation(["Preferences"]);

  return (
    <div className="m-4 d-flex justify-content-between">
      <div className="fw-600 col-3">
        {t("NotificationPreferences.CollaboratorNotifications")}
      </div>
      <div className="col-9">
        <div className="mb-2">
          {t("NotificationPreferences.AsATaskCollaborator")}
        </div>
        <div className="notification-content">
          <PreferenceComponent
            ref={addedAsCollaboratorEmailEnabledRef}
            title={t("NotificationPreferences.AddedAsCollaborator")}
            checkedValue={userNotificationData?.AddedAsCollaboratorEmailEnabled}
            change={onChange}
          />
        </div>
      </div>
    </div>
  );
};
